import React from 'react'
import { connect } from 'react-redux'

import Titulo from '../comum/Titulo'
import Autorizacao from '../../security/Autorizacao'
import { PERFIL_ADMIN, getAdminEmpresa, getOperadorRemarcacao } from '../../security/securityContext'
import buscarVendasUrbanas from '../../actions/vendaUrbana/buscarVendasUrbanas'
import buscarVendaUrbanaPorId from '../../actions/vendaUrbana/buscarVendaUrbanaPorId'
import cancelarVendaUrbana from '../../actions/vendaUrbana/cancelarVendaUrbana'
import ModalConfirmacaoCancelamentoVendaUrbana from './ModalConfirmacaoCancelamentoVendaUrbana'
import { showErrorMsg } from '../../util/messagesUtil'

// Ícones validados contra node_modules/material-design-icons/iconfont/codepoints
// (qr_code e payments não existem nessa versão do pacote e renderizavam glifos quebrados)
function iconeFormaPagamento (descricao) {
  const texto = (descricao || '').toLowerCase()
  if (texto.includes('pix')) return { icone: 'flash_on', cor: 'teal' }
  if (texto.includes('dinheiro')) return { icone: 'local_atm', cor: 'green' }
  if (texto.includes('cart')) return { icone: 'credit_card', cor: 'blue' }
  return { icone: 'attach_money', cor: 'orange' }
}

// Codigos alinhados com o enum TipoPagamento do backend (TipoPagamento.getCod())
const OPCOES_FORMA_PAGAMENTO = [
  { cod: 3, label: 'Dinheiro' },
  { cod: 7, label: 'PIX' },
  { cod: 6, label: 'Cartão de Crédito' },
  { cod: 2, label: 'Cartão de Débito' }
]

const OPCOES_REGISTROS_POR_PAGINA = [10, 20, 50, 100]

export class PainelGerenciarVendasUrbanas extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      filtro: {
        id: '',
        nomeVendedor: '',
        nomePassageiro: '',
        formaPagamento: '',
        valorMinimo: '',
        valorMaximo: ''
      },
      paginaAtual: 1,
      registrosPorPagina: 20,
      vendaParaCancelar: null
    }
  }

  componentDidMount () {
    this.buscar()
  }

  buscar () {
    const { filtro, paginaAtual, registrosPorPagina } = this.state
    this.props.buscarVendasUrbanas(this.props.empresaSelecionada.id, {
      ...filtro,
      formasPagamento: filtro.formaPagamento ? [filtro.formaPagamento] : [],
      from: paginaAtual,
      size: registrosPorPagina
    })
  }

  buscarDoInicio () {
    this.setState({ paginaAtual: 1 }, () => this.buscar())
  }

  irParaPagina (pagina) {
    this.setState({ paginaAtual: pagina }, () => this.buscar())
  }

  alterarRegistrosPorPagina (valor) {
    this.setState({ registrosPorPagina: Number(valor), paginaAtual: 1 }, () => this.buscar())
  }

  limparFiltros () {
    this.setState({
      filtro: { id: '', nomeVendedor: '', nomePassageiro: '', formaPagamento: '', valorMinimo: '', valorMaximo: '' },
      paginaAtual: 1
    }, () => this.buscar())
  }

  alterarFiltro (campo, valor) {
    this.setState({ filtro: { ...this.state.filtro, [campo]: valor } })
  }

  imprimirCupom (venda) {
    this.props.buscarVendaUrbanaPorId(venda.id, this.props.empresaSelecionada.id).then(() => {
      this.props.history.push('/recibo-venda-urbana')
    })
  }

  abrirCancelamento (venda) {
    this.setState({ vendaParaCancelar: venda })
  }

  confirmarCancelamento (motivo) {
    const venda = this.state.vendaParaCancelar
    this.props.cancelarVendaUrbana({
      idEmpresa: this.props.empresaSelecionada.id,
      idVendaUrbana: venda.id,
      motivo
    }).then(() => {
      this.setState({ vendaParaCancelar: null })
      this.buscar()
    }).catch(erro => {
      if (!navigator.onLine || !erro.response) {
        showErrorMsg('Sem conexão com a internet. Não é possível cancelar vendas urbanas offline.')
        return
      }
      throw erro
    })
  }

  render () {
    const emp = this.props.empresaSelecionada
    const vendasUrbanas = (this.props.vendasUrbanas && this.props.vendasUrbanas.vendasUrbanas) || []
    const total = (this.props.vendasUrbanas && this.props.vendasUrbanas.total) || 0
    const { paginaAtual, registrosPorPagina } = this.state
    const totalPaginas = Math.max(1, Math.ceil(total / registrosPorPagina))
    const primeiroRegistro = total === 0 ? 0 : (paginaAtual - 1) * registrosPorPagina + 1
    const ultimoRegistro = Math.min(paginaAtual * registrosPorPagina, total)

    return (
      <div className="row internas">
        <Titulo texto="Gerenciar   vendas urbanas" urlRetorno="/dashboard"/>
        <div className="col-12">
          <p className="text-muted" style={{ marginTop: -12, marginBottom: 16 }}>
            Lista de passagens vendidas no módulo de vendas urbanas.
          </p>
        </div>

        <div className="col-12">
          <div className="d-flex justify-content-end mb-3">
            <button className="vx-btn-primary" onClick={() => this.props.history.push('/painel-cadastro-venda-urbana')}>
              <i className="material-icons">add</i> Nova venda urbana
            </button>
          </div>

          <div className="vx-modal-section">
            <div className="vx-modal-section-title">
              <i className="material-icons">filter_list</i> Filtros de consulta
            </div>
            <div className="form-row">
              <div className="col-md-2">
                <label>ID reserva urbana</label>
                <input type="text" className="form-control" placeholder="Ex.: 123456"
                       value={this.state.filtro.id}
                       onChange={event => this.alterarFiltro('id', event.target.value)}/>
              </div>
              <div className="col-md-3">
                <label>Nome vendedor</label>
                <input type="text" className="form-control"
                       value={this.state.filtro.nomeVendedor}
                       onChange={event => this.alterarFiltro('nomeVendedor', event.target.value)}/>
              </div>
              <div className="col-md-3">
                <label>Nome passageiro</label>
                <input type="text" className="form-control"
                       value={this.state.filtro.nomePassageiro}
                       onChange={event => this.alterarFiltro('nomePassageiro', event.target.value)}/>
              </div>
              <div className="col-md-2">
                <label>Forma de pagamento</label>
                <select className="form-control" value={this.state.filtro.formaPagamento}
                        onChange={event => this.alterarFiltro('formaPagamento', event.target.value)}>
                  <option value="">Selecione...</option>
                  {OPCOES_FORMA_PAGAMENTO.map(opcao => (
                    <option key={opcao.cod} value={opcao.cod}>{opcao.label}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-2">
                <label>Valor mínimo</label>
                <input type="text" className="form-control"
                       value={this.state.filtro.valorMinimo}
                       onChange={event => this.alterarFiltro('valorMinimo', event.target.value)}/>
              </div>
              <div className="col-md-2">
                <label>Valor máximo</label>
                <input type="text" className="form-control"
                       value={this.state.filtro.valorMaximo}
                       onChange={event => this.alterarFiltro('valorMaximo', event.target.value)}/>
              </div>
            </div>
            <div className="form-row mt-3">
              <div className="col-auto">
                <button className="vx-btn-primary" onClick={() => this.buscarDoInicio()}>
                  <i className="material-icons">search</i> Buscar
                </button>
              </div>
              <div className="col-auto">
                <button className="vx-btn-secondary" onClick={() => this.limparFiltros()}>
                  <i className="material-icons">refresh</i> Limpar filtros
                </button>
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center mb-3" style={{
            background: '#e3f2fd', color: '#1565c0', padding: '10px 14px', borderRadius: 8, fontSize: 13
          }}>
            <i className="material-icons mr-2" style={{ fontSize: 18 }}>info</i>
            Cancelar visível apenas para admin empresa ou operador remarcação.
          </div>

          <div className="vx-modal-section" style={{ overflowX: 'auto' }}>
            <table className="table">
              <thead>
                <tr>
                  <th>ID Pedido</th>
                  <th>ID reserva urbana</th>
                  <th>Nome vendedor</th>
                  <th>Nome passageiro</th>
                  <th>Forma de pagamento</th>
                  <th>Valor pago</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {vendasUrbanas.map(venda => {
                  const pagamento = iconeFormaPagamento(venda.descricaoFormaPagamento)
                  return (
                    <tr key={venda.id}>
                      <td>{venda.idPedido}</td>
                      <td>{venda.id}</td>
                      <td>{venda.nomeVendedor}</td>
                      <td>{venda.nomePassageiro}</td>
                      <td>
                        <div className="d-flex align-items-center">
                          {venda.descricaoFormaPagamento}
                          <div className={`vx-action-icon-wrap c-${pagamento.cor} ml-2`} style={{ width: 26, height: 26 }}>
                            <i className="material-icons" style={{ fontSize: 15 }}>{pagamento.icone}</i>
                          </div>
                        </div>
                      </td>
                      <td>R$ {venda.valor}</td>
                      <td>
                        <span className={`vx-badge ${venda.situacao === 'CANCELADA' ? 'vx-badge-danger' : 'vx-badge-success'}`}>
                          {venda.descricaoSituacao}
                        </span>
                      </td>
                      <td>
                        {venda.situacao !== 'CANCELADA' && (
                          <button className="vx-btn-primary mr-2" onClick={() => this.imprimirCupom(venda)}>
                            <i className="material-icons">print</i> Imprimir cupom
                          </button>
                        )}
                        {venda.sePodeCancelar && (
                          <Autorizacao
                            perfisPermitidos={[PERFIL_ADMIN, getAdminEmpresa(emp.id), getOperadorRemarcacao(emp.id)]}
                            empresaSelecionada={emp}
                          >
                            <button className="vx-btn-danger" onClick={() => this.abrirCancelamento(venda)}>
                              <i className="material-icons">delete</i> Cancelar
                            </button>
                          </Autorizacao>
                        )}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            {vendasUrbanas.length === 0 && (
              <div className="text-muted text-center p-3">Nenhuma venda urbana encontrada.</div>
            )}

            {vendasUrbanas.length > 0 && (
              <div className="d-flex justify-content-between align-items-center flex-wrap mt-3" style={{ gap: 10 }}>
                <small className="text-muted">
                  Mostrando {primeiroRegistro} a {ultimoRegistro} de {total} resultados
                </small>
                <div className="d-flex align-items-center" style={{ gap: 10 }}>
                  <div className="d-flex align-items-center" style={{ gap: 4 }}>
                    <button className="vx-btn-secondary" disabled={paginaAtual <= 1}
                            onClick={() => this.irParaPagina(paginaAtual - 1)}>
                      <i className="material-icons" style={{ fontSize: 15 }}>chevron_left</i>
                    </button>
                    <span style={{ fontSize: 13, padding: '0 6px' }}>{paginaAtual}</span>
                    <button className="vx-btn-secondary" disabled={paginaAtual >= totalPaginas}
                            onClick={() => this.irParaPagina(paginaAtual + 1)}>
                      <i className="material-icons" style={{ fontSize: 15 }}>chevron_right</i>
                    </button>
                  </div>
                  <select className="form-control" style={{ width: 'auto' }}
                          value={registrosPorPagina}
                          onChange={event => this.alterarRegistrosPorPagina(event.target.value)}>
                    {OPCOES_REGISTROS_POR_PAGINA.map(opcao => (
                      <option key={opcao} value={opcao}>{opcao} por página</option>
                    ))}
                  </select>
                </div>
              </div>
            )}
          </div>
        </div>

        {this.state.vendaParaCancelar && (
          <ModalConfirmacaoCancelamentoVendaUrbana
            venda={this.state.vendaParaCancelar}
            onFechar={() => this.setState({ vendaParaCancelar: null })}
            onConfirmar={motivo => this.confirmarCancelamento(motivo)}
          />
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  empresaSelecionada: state.empresaSelecionada,
  vendasUrbanas: state.vendasUrbanas
})

export default connect(mapStateToProps, {
  buscarVendasUrbanas,
  buscarVendaUrbanaPorId,
  cancelarVendaUrbana
})(PainelGerenciarVendasUrbanas)
